/* Urun sayfasi galerisi (mobil): ok butonlari, noktalar ve kucuk resim seridi. */
(function () {
  function chevron(dir) {
    var d = dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
  }

  function button(cls, label, html) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    if (html) b.innerHTML = html;
    return b;
  }

  function scrollBy(el, delta) {
    if (el.scrollTo) {
      el.scrollTo({ left: el.scrollLeft + delta, behavior: 'smooth' });
    } else {
      el.scrollLeft += delta;
    }
  }

  function init(root) {
    if (root.getAttribute('data-elv-gallery')) return;
    var scroller = root.querySelector('.yv-product-gallery-items');
    if (!scroller) return;
    var items = Array.prototype.slice.call(scroller.querySelectorAll('.gallery-main-item'));
    if (items.length < 2) return;
    root.setAttribute('data-elv-gallery', '1');

    var last = items.length - 1;
    var active = -1;

    var wrap = document.createElement('div');
    wrap.className = 'elv-gallery-wrap';
    scroller.parentNode.insertBefore(wrap, scroller);
    wrap.appendChild(scroller);

    var prev = button('elv-gallery-arrow elv-gallery-prev', 'Önceki görsel', chevron('prev'));
    var next = button('elv-gallery-arrow elv-gallery-next', 'Sonraki görsel', chevron('next'));
    wrap.appendChild(prev);
    wrap.appendChild(next);

    var dotsBox = document.createElement('div');
    dotsBox.className = 'elv-gallery-dots';
    var thumbsBox = document.createElement('div');
    thumbsBox.className = 'elv-gallery-thumbs' + (items.length <= 3 ? ' is-static' : '');
    var track = document.createElement('div');
    track.className = 'elv-thumbs-track';
    var tPrev = button('elv-thumbs-arrow elv-thumbs-prev', 'Önceki küçük resimler', chevron('prev'));
    var tNext = button('elv-thumbs-arrow elv-thumbs-next', 'Sonraki küçük resimler', chevron('next'));

    var dots = [];
    var thumbs = [];
    items.forEach(function (item, i) {
      var label = 'Görsel ' + (i + 1);
      var dot = button('elv-gallery-dot', label);
      dot.addEventListener('click', function () { goTo(i); });
      dotsBox.appendChild(dot);
      dots.push(dot);

      var source = item.id ? root.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"] img') : null;
      if (!source) source = item.querySelector('img');
      var url = source ? (source.getAttribute('data-src') || source.getAttribute('src') || source.getAttribute('data-original') || '') : '';
      url = url.replace('{width}', '300');

      var thumb = button('elv-thumb', label);
      if (url) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = source.getAttribute('alt') || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      thumb.addEventListener('click', function () { goTo(i); });
      track.appendChild(thumb);
      thumbs.push(thumb);
    });

    thumbsBox.appendChild(tPrev);
    thumbsBox.appendChild(track);
    thumbsBox.appendChild(tNext);
    root.appendChild(dotsBox);
    root.appendChild(thumbsBox);

    function currentIndex() {
      var left = scroller.getBoundingClientRect().left;
      var best = 0;
      var bestDistance = Infinity;
      items.forEach(function (item, i) {
        var distance = Math.abs(item.getBoundingClientRect().left - left);
        if (distance < bestDistance) { bestDistance = distance; best = i; }
      });
      return best;
    }

    function goTo(i) {
      i = Math.max(0, Math.min(last, i));
      scrollBy(scroller, items[i].getBoundingClientRect().left - scroller.getBoundingClientRect().left);
    }

    function updateTrackArrows() {
      tPrev.disabled = track.scrollLeft <= 1;
      tNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    function update() {
      var i = currentIndex();
      prev.disabled = i === 0;
      next.disabled = i === last;
      if (i !== active) {
        active = i;
        dots.forEach(function (dot, n) {
          dot.classList.toggle('is-active', n === i);
          if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        thumbs.forEach(function (thumb, n) { thumb.classList.toggle('is-active', n === i); });
        var box = track.getBoundingClientRect();
        var rect = thumbs[i].getBoundingClientRect();
        if (box.width && (rect.left < box.left - 1 || rect.right > box.right + 1)) {
          scrollBy(track, rect.left - box.left - (box.width - rect.width) / 2);
        }
      }
      updateTrackArrows();
    }

    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }

    prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    tPrev.addEventListener('click', function () { scrollBy(track, -track.clientWidth); });
    tNext.addEventListener('click', function () { scrollBy(track, track.clientWidth); });
    scroller.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('.product-section .yv-product-gallery-slider.gallery-style');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
